<mat-tab-group mat-align-tabs="center" dynamicHeight animationDuration="0ms" color="accent">
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="tabIcon">group</mat-icon>
            Users
        </ng-template>
        <app-users></app-users>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="tabIcon">how_to_reg</mat-icon>
            Roles
        </ng-template>
        <app-roles></app-roles>
    </mat-tab>
</mat-tab-group>
